import React from 'react'
import Axios from 'axios'
import '../../App.css'
import './Contact.css'
import BackgroundSection from '../BackgroundSection'
import ContainerSection from '../ContainerSection'
import { Title } from '../Title'
import { Button } from '../Button'

class Contact extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      name: '',
      email: '',
      message: '',
      disabled: false,
      emailSent: null,
    }
  }

  handleChange = (event) => {
    const target = event.target
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.name

    this.setState({
      [name]: value,
    })
  }

  handleSubmit = (event) => {
    event.preventDefault()

    console.log(event.target)

    this.setState({
      disabled: true,
    })

    Axios.post('http://localhost:5000/api/email', this.state)
      .then((res) => {
        if (res.data.success) {
          this.setState({
            disabled: false,
            emailSent: true,
          })
        } else {
          this.setState({
            disabled: false,
            emailSent: false,
          })
        }
      })
      .catch((err) => {
        console.log(err)

        this.setState({
          disabled: false,
          emailSent: false,
        })
      })
  }

  render() {
    return (
      <>
        <BackgroundSection
          className='background'
          backgroundStyle='background--ninth'
        >
          Contact
        </BackgroundSection>
        <ContainerSection
          className='container'
          containerStyle='container--conone'
        >
          <Title
            className='title'
            titleStyle='title--trans'
            titleSize='title--large'
          >
            Contact Us
          </Title>

          <form onSubmit={this.handleSubmit} className='con-form'>
            <div className='con-group'>
              <label htmlFor='full-name' className='con-title'>
                Full Name
              </label>
              <input
                className='con-input'
                id='full-name'
                name='name'
                type='text'
                value={this.state.name}
                onChange={this.handleChange}
              />
            </div>

            <div className='con-group'>
              <label htmlFor='email' className='con-title'>
                Email
              </label>
              <input
                className='con-input'
                id='email'
                name='email'
                type='email'
                value={this.state.email}
                onChange={this.handleChange}
              />
            </div>

            <div className='con-group'>
              <label htmlFor='message' className='con-title'>
                Message
              </label>
              <textarea
                className='con-text'
                id='message'
                name='message'
                as='textarea'
                rows='3'
                value={this.state.message}
                onChange={this.handleChange}
              />
            </div>

            <div className='con-group'>
              <Button
                className='btn'
                buttonStyle='btn--pri'
                buttonSize='btn--large'
                path='/contact'
                type='submit'
                disabled={this.state.disabled}
              >
                SEND
              </Button>
            </div>
            {this.state.emailSent === true && (
              <p className='d-inline success-msg'>Email Sent</p>
            )}
            {this.state.emailSent === false && (
              <p className='d-inline err-msg'>Email Not Sent</p>
            )}
          </form>
        </ContainerSection>
      </>
    )
  }
}

export default Contact
